function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "256",
  height: "256",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("title", null, "Clapboard"), /*#__PURE__*/React.createElement("g", {
  id: "Canvas"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clapboard",
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_fill",
  transform: "translate(2 92)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 19"
}), /*#__PURE__*/React.createElement("g", {
  id: "Bottom Clapper",
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path1_fill",
  transform: "translate(2 92)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 20"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "matrix(1 0 0 -1 30 122)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "matrix(1 0 0 -1 76 122)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "matrix(1 0 0 -1 122 122)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "matrix(1 0 0 -1 168 122)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "matrix(1 0 0 -1 214 122)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
})), /*#__PURE__*/React.createElement("g", {
  id: "Top Clapper",
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path3_fill",
  transform: "rotate(-15.15 239.32 -32.46)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 20"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "rotate(-15.15 148.46 -758.71)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "rotate(-15.15 240.46 -67.04)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "rotate(-15.15 217.46 -239.96)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "rotate(-15.15 194.46 -412.87)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "rotate(-15.15 171.46 -585.8)",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 23"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path4_fill",
  transform: "translate(12 147)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 24"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path4_fill",
  transform: "translate(12 197)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 24"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path4_fill",
  transform: "translate(12 231)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 24"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(86 149)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 25"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(168 149)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 25"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path6_fill",
  transform: "translate(0 58)",
  fill: "#4C4C4C",
  style: {
    mixBlendMode: "normal"
  },
  id: "Rectangle 26"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(14 102)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Ellipse 7"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(43 102)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Ellipse 7"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(14 70)",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  id: "Ellipse 7"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_fill",
  d: "M0 0h252v156a8 8 0 01-8 8H8a8 8 0 01-8-8V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1_fill",
  d: "M0 1a1 1 0 011-1h252a1 1 0 011 1v30a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2_fill",
  d: "M0 0h23.75L38 28H14.25L0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3_fill",
  d: "M0 1a1 1 0 011-1h233a1 1 0 011 1v30a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path4_fill",
  d: "M0 0h232v2H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path5_fill",
  d: "M0 0h2v48H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path6_fill",
  d: "M0 4a4 4 0 014-4h32.25a4 4 0 013.28 1.7l42.06 60A4 4 0 0178.3 68H4a4 4 0 01-4-4V4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path7_fill",
  d: "M12 6A6 6 0 110 6a6 6 0 0112 0z"
})));